import type { ExternalSubmissionViewRow } from "../../lib/forms/externalSubmissionView";

export function SubmissionAnswersList({
  rows,
}: {
  rows: ExternalSubmissionViewRow[];
}) {
  if (rows.length === 0) {
    return (
      <div className="px-5 py-8 text-center font-onest text-sm text-slate-500 sm:px-8">
        В ответе нет полей
      </div>
    );
  }

  return (
    <dl className="divide-y divide-slate-100">
      {rows.map((row) => (
        <div
          key={row.key}
          className="grid gap-1 px-5 py-4 sm:grid-cols-[12rem_minmax(0,1fr)] sm:gap-4 sm:px-8"
        >
          <dt className="font-onest text-sm text-slate-500">{row.label}</dt>
          <dd className="whitespace-pre-wrap font-onest text-sm font-medium text-slate-800">
            {row.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
